import React from 'react';

const TermsOfService = () => {
	return (
		<div className=" min-h-screen bg-[url('/img/background.png')] py-4 px-4 sm:px-6 lg:px-8">
			<div className='max-w-5xl mx-auto bg-white shadow-toast rounded-lg overflow-hidden border border-popover-100'>
				{/* Header */}
				<div className='bg-gradient-to-r from-popover-1000 to-popover-800 px-6 py-4'>
					<h1 className='text-3xl font-bold text-white'>
						Terms of Service
					</h1>
					<p className='text-blue-100 mt-1'>
						Last updated: May 16, 2025
					</p>
				</div>

				{/* Content Container */}
				<div className='p-6 sm:p-8'>
					{/* Introduction */}
					<section
						id='introduction'
						className='mb-8'>
						<p className='text-gray-700 mb-4'>
							These Terms of Service ("Terms") govern your use of
							the OwnInn hotel booking and management service
							("Service"), provided by OwnInn ("Company", "We",
							"Us", or "Our"). By accessing or using the Service,
							you agree to be bound by these Terms. If you do not
							agree, please refrain from using the Service.
						</p>
						<p className='text-gray-700'>
							The Service allows you to book hotel rooms, manage
							reservations, and access related features. We may
							update these Terms from time to time, and any
							changes will be posted here with an updated "Last
							updated" date. Continued use of the Service after
							changes constitutes acceptance of the new Terms.
						</p>
					</section>

					{/* Acceptable Use */}
					<section
						id='acceptable-use'
						className='mb-8'>
						<h2 className='text-2xl font-semibold text-gray-800 mb-4'>
							Acceptable Use
						</h2>
						<p className='text-gray-600 mb-4'>
							You agree to use the Service only for lawful
							purposes and in accordance with these Terms. You
							must not:
						</p>
						<ul className='list-disc pl-5 space-y-2 text-gray-600 mb-4'>
							<li>
								Engage in fraudulent booking activities or
								attempt to manipulate prices.
							</li>
							<li>
								Post or transmit illegal, offensive, or
								copyrighted content.
							</li>
							<li>
								Attempt to hack, disrupt, or interfere with the
								Service’s functionality.
							</li>
							<li>
								Use the Service to spam, harass, or defame other
								users or hotels.
							</li>
						</ul>
						<p className='text-gray-600'>
							We reserve the right to suspend or terminate your
							account and access to the Service if you violate
							these rules.
						</p>
					</section>

					{/* Payment Terms */}
					<section
						id='payment-terms'
						className='mb-8'>
						<h2 className='text-2xl font-semibold text-gray-800 mb-4'>
							Payment Terms
						</h2>
						<p className='text-gray-600 mb-4'>
							Booking a hotel room through the Service requires
							payment. All prices are in the currency displayed at
							the time of booking and include applicable taxes
							unless stated otherwise. Payments are processed
							securely via our third-party payment providers.
						</p>
						<ul className='list-disc pl-5 space-y-2 text-gray-600 mb-4'>
							<li>
								Payments are due at the time of booking unless a
								hotel offers a deferred payment option.
							</li>
							<li>
								Refunds are subject to the cancellation policy
								of the individual hotel.
							</li>
							<li>
								Subscription fees (if applicable) are billed
								monthly or annually and can be canceled with 30
								days’ notice.
							</li>
						</ul>
						<p className='text-gray-600'>
							We are not responsible for payment disputes; please
							contact your payment provider or the hotel directly.
						</p>
					</section>

					{/* Disclaimer of Warranties */}
					<section
						id='disclaimer'
						className='mb-8'>
						<h2 className='text-2xl font-semibold text-gray-800 mb-4'>
							Disclaimer of Warranties
						</h2>
						<p className='text-gray-600 mb-4'>
							The Service is provided "as is" and "as available"
							without warranties of any kind, either express or
							implied. We do not guarantee uninterrupted or
							error-free operation of the Service, nor do we
							warrant that it will meet your specific
							requirements.
						</p>
						<p className='text-gray-600'>
							We are not liable for any indirect damages,
							including loss of profits, arising from your use of
							the Service or reliance on hotel information
							provided through it.
						</p>
					</section>

					{/* Changes to Terms */}
					<section
						id='changes-to-terms'
						className='mb-8'>
						<h2 className='text-2xl font-semibold text-gray-800 mb-4'>
							Changes to These Terms
						</h2>
						<p className='text-gray-600 mb-4'>
							We may modify these Terms at our discretion. Updated
							Terms will be posted on this page with a revised
							"Last updated" date. We will notify you via email or
							a prominent notice on the Service at least 30 days
							before changes take effect.
						</p>
						<p className='text-gray-600'>
							Your continued use of the Service after the
							effective date constitutes acceptance of the
							modified Terms.
						</p>
					</section>

					{/* Jurisdiction and Dispute Resolution */}
					<section
						id='jurisdiction'
						className='mb-8'>
						<h2 className='text-2xl font-semibold text-gray-800 mb-4'>
							Jurisdiction and Dispute Resolution
						</h2>
						<p className='text-gray-600 mb-4'>
							These Terms are governed by the laws of Georgia. Any
							disputes arising from your use of the Service will
							be resolved through negotiation. If unresolved,
							disputes will be subject to the exclusive
							jurisdiction of the courts in Tbilisi, Georgia.
						</p>
						<p className='text-gray-600'>
							For international users, we recommend complying with
							local laws (e.g., GDPR for EU residents), and we may
							adapt these Terms accordingly.
						</p>
					</section>

					{/* Contact Us */}
					<section
						id='contact-us'
						className='border-t border-gray-200 pt-6'>
						<h2 className='text-2xl font-semibold text-gray-800 mb-4'>
							Contact Us
						</h2>
						<p className='text-gray-600 mb-4'>
							If you have questions about these Terms, please
							contact us:
						</p>
						<ul className='list-disc pl-5 space-y-2 text-gray-600'>
							<li>
								By email:{' '}
								<a
									href='mailto:info@owninn.gek'
									className='text-blue-600 hover:underline'>
									info@owninn.ge
								</a>
							</li>
						</ul>
					</section>
				</div>
			</div>
		</div>
	);
};

export default TermsOfService;
